import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SignedInLinks from './SignedInLinks';
import SignedOutLinks from './SignedOutLinks';
import { connect } from 'react-redux';
import { signOut } from '../../store/actions/authActions';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { initNavigationDrawer } from '../../components/general/NavigationDrawer';

function Navbar(props) {
  const { auth, profile, signOut, mobile } = props;

  const links = () => {
    return (
      auth.uid ? <SignedInLinks profile={profile} /> : <SignedOutLinks />
    )
  };

  useEffect(() => {
    initNavigationDrawer();
  }, []);

  const profileImage = () => {
    return (profile && profile.avatar) ? ('images/avatar/' + profile.avatar + '.png') : 'images/avatar/type1.png';
  }

  const profileFullName = () => {
    return (profile && profile.name && profile.lastName) ? (profile.name + ' ' + profile.lastName) : 'Unknown';
  }

  const profileEmail = () => {
    return profile ? profile.email : '';
  }

  const currentUser = () => {
    return (
      <li>
        <div className="user-view">
          <div className="background" style={{ background: '#333333' }}></div>
          <a href="#user">
            <img alt="" className="circle" src={profileImage()} />
          </a>
          <a href="#name">
            <span className="white-text name">{profileFullName()}</span>
          </a>
          <a href="#email">
            <span className="white-text email">{profileEmail()}</span>
          </a>
        </div>
      </li>
    )
  }

  const renderHome = () => {
    return (
      <React.Fragment>
        <li>
          <a href="#Settings" className="subheader"><i className="material-icons">home</i>Home</a>
        </li>
        <li>
          <Link to="badges"><i className="material-icons">chevron_right</i>Safety Badges</Link>
        </li>
        <li>
          <div className="divider"></div>
        </li>
      </React.Fragment>
    )
  }

  const renderInbox = () => {
    return (
      <React.Fragment>
        <li>
          <a href="#Settings" className="subheader"><i className="material-icons">inbox</i>Inbox</a>
        </li>
        <li>
          <Link to="notifications"><i className="material-icons">chevron_right</i>Notifications</Link>
        </li>
        <li>
          <Link to="userInbox"><i className="material-icons">chevron_right</i>User Inbox</Link>
        </li>
        <li>
          <Link to="messageTemplates"><i className="material-icons">chevron_right</i>Message Templates</Link>
        </li>
        <li>
          <Link to="activities"><i className="material-icons">chevron_right</i>Activities</Link>
        </li>

        <li>
          <div className="divider"></div>
        </li>
      </React.Fragment>
    )
  }

  const renderTryps = () => {
    return (
      <React.Fragment>
        <li>
          <a href="#Settings" className="subheader"><i className="material-icons">directions_car</i>Tryps</a>
        </li>
        <li>
          <Link to="companies"><i className="material-icons">chevron_right</i>Companies</Link>
        </li>
        <li>
          <Link to="pyns"><i className="material-icons">chevron_right</i>Pyns</Link>
        </li>
        <li>
          <Link to="places"><i className="material-icons">chevron_right</i>Places Search</Link>
        </li>
        <li>
          <div className="divider"></div>
        </li>
      </React.Fragment>
    )
  }

  const renderNavigationDrawer = () => {
    return (
      <ul id="navigation-drawer" className="sidenav">
        {currentUser()}
        {renderHome()}
        {renderInbox()}
        {renderTryps()}
        <li>
          <a href="#Settings" className="subheader"><i className="material-icons">settings</i>Settings</a>
        </li>
        <li>
          <a className="waves-effect" href="#logout" onClick={signOut}><i className="material-icons">chevron_right</i>Log Out
          </a>
        </li>
      </ul>
    );
  };

  const renderNavItemsForMobile = () => {
    return (
      <div className="brand-logo">
        <img alt="" className="left banner-logo" src="images/trypscore_white.png" />
      </div>
    );
  };

  const renderGeneralNavItems = () => {
    return (
      <div>
        <div className="brand-logo">
          {/*
              <a href="#" data-target="slide-out" className="sidenav-trigger sidenav-always">
                <i className="material-icons">menu</i>
              </a>*/}
          <Link to="/">
            <img alt="" className="left banner-logo" src="images/trypscore_white.png" />
          </Link>
        </div>
        {links()}
      </div>
    );
  };

  return (
    <nav className="nav-wrapper grey darken-3">
      {renderNavigationDrawer()}
      <div className="container">
        {mobile ? renderNavItemsForMobile() : renderGeneralNavItems()}
      </div>
    </nav>
  );
};

const mapStateToProps = (state) => {
  const profile = state.firestore.data['currentProfile'];
  return {
    auth: state.firebase.auth,
    profile: profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    const currentProfile = [];
    if (props.auth.uid != null) {
      currentProfile.push(
        {
          collection: 'profiles',
          doc: props.auth.uid,
          storeAs: 'currentProfile'
        });
    }
    return currentProfile;
  }),
)(Navbar);
